
/* eslint-disable */
import { v4 as uuidv4 } from 'uuid';
import Recipe from '../../../models/recipe'

export default {

    setTabStatus(state, status) {
        state.tabStatus = status
    },
    setEmptyRecipe(state) {
        state.currentRecipe = Recipe
    },
    setUnits(state, units) {
        state.units = units
    },
    setIngredients(state, ingredients) {
        state.ingredients = ingredients
    },
    setShowIngredientsModal(state, value) {
        state.showIngredientsModal = value
    },
    setCategories(state, categories) {
        state.categories = categories
    },
    setRecipeField(state, { fieldName, value }) {
        state.currentRecipe[fieldName] = value
    },
    setRecipe(state, payload) {
        state.currentRecipe = payload
    },
    setFieldOptions(state, options) {
        state.fieldOptions = options
    },
    setRecipeList(state, options) {
        state.recipeList = options
    },
    setRecipeValidation(state, errors) {
        let recipeErrors = JSON.parse(JSON.stringify({
            "title": null,
            "description": null,
            "categories": null,
        }))
        recipeErrors = Object.assign(recipeErrors, errors)
        state.currentRecipeErrors = recipeErrors
    },
    setEmptyRecipeValidation(state) {
        state.currentRecipeErrors = {}
    },
    addIngredientGroupToCurrentRecipe(state) {
        state.currentRecipe.ingredient_groups.push({
            name: '',
            items: [],
            position: state.currentRecipe.ingredient_groups.length + 1,
            recipe: state.currentRecipe.id,
            status: 'create',
            id: uuidv4()
        })
    },
    addInstructionGroupToCurrentRecipe(state) {
        state.currentRecipe.instruction_groups.push({
            name: '',
            instructions: [],
            position: state.currentRecipe.instruction_groups.length + 1,
            recipe: state.currentRecipe.id,
            status: 'create',
            id: uuidv4()
        })
    },
    addIngredientToGroupCurrentRecipe(state, groupId) {
        for (let i = 0; i < state.currentRecipe.ingredient_groups.length; i++) {
            if (state.currentRecipe.ingredient_groups[i].id === groupId) {
                console.log(state.currentRecipe.ingredient_groups[i])
                state.currentRecipe.ingredient_groups[i].items.push({
                    ingredient: null,
                    note: null,
                    amount: '0',
                    status: 'create',
                    position: state.currentRecipe.ingredient_groups[i].items.length + 1,
                    id: uuidv4(),
                })
            }
        }
    },
    addInstructionToGroupCurrentRecipe(state, groupId) {
        for (let i = 0; i < state.currentRecipe.instruction_groups.length; i++) {
            if (state.currentRecipe.instruction_groups[i].id === groupId) {
                state.currentRecipe.instruction_groups[i].instructions.push({
                    instruction: '',
                    status: 'create',
                    position: state.currentRecipe.instruction_groups[i].instructions.length + 1,
                    id: uuidv4(),
                })
            }
        }
    },

    setCurrentIngredient(state, ingredient) {
        state.currentIngredient = ingredient
    },
    setEmptyIngredient(state) {
        state.currentIngredient = {
            name: '',
            unit: null,
            image: ''
        }
    },
    setCurrentIngredientMode(state, mode) {
        state.currentIngredientMode = mode
    },
    currentIngredientField(state, { fieldName, value }) {
        state.currentIngredient[fieldName] = value
    },
    setIngredientItemNumericQuantity(state, data) {
        state.ingredientItemNumericQuantity = data
    },
    setRecipeStatus(state, payload) {
        state.currentRecipe.status = payload
    },
    setDietaryOptions(state, payload) {
        state.dietaryOptions = payload.results
    },
    setUsersOptions(state, payload) {
        state.users = payload
    },
    setRecipesOptions(state, payload) {
        state.recipesOptions = payload
    },
    updateInstruction(state, payload) {

        for (let i = 0; i < state.currentRecipe.instruction_groups.length; i++) {
            if (state.currentRecipe.instruction_groups[i].id === payload.groupId) {
                const items = JSON.parse(JSON.stringify(state.currentRecipe.instruction_groups[i].instructions));
                for (let i = 0; i < items.length; i++) {
                    const currentItem = items[i];
                    if (payload.item.uuid === currentItem.id) {
                        items[i].id = payload.item.itemId;
                        items[i].instruction = payload.item.instruction;
                    }
                }
                state.currentRecipe.instruction_groups[i].instructions = items
            }
        }

    },
    updateIngredients(state, payload) {

        for (let i = 0; i < state.currentRecipe.ingredient_groups.length; i++) {
            if (state.currentRecipe.ingredient_groups[i].id === payload.groupId) {
                const items = JSON.parse(JSON.stringify(state.currentRecipe.ingredient_groups[i].items));

                for (let i = 0; i < items.length; i++) {
                    const currentItem = items[i];
                    if (payload.item.uuid === currentItem.id) {
                        items[i].id = payload.item.itemId;
                        items[i].ingredient_group = payload.item.ingredient_group;
                        items[i].position = payload.item.position;
                        items[i].amount = payload.item.amount;
                        items[i].note = payload.item.note;
                        items[i].ingredient = payload.item.ingredient;
                        items[i].unit = payload.item.unit;
                        items[i].status = payload.item.added;
                    }
                }

                state.currentRecipe.ingredient_groups[i].items = items
            }
        }

    }
}